import { useState, useRef, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import PlacesAutocomplete from "../autocomplete/AutoComplete";
import CustomButton from "../button/Button";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const MapModal = ({ onClose, onSelectLocation, initialLocation }) => {
  const [location, setLocation] = useState(initialLocation);
  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const markerRef = useRef(null);

  const handleMapClick = ({ lat, lng }) => {
    setLocation({ ...location, lat, lng });
  };

  const handleSelectLocation = (selectedLocation) => {
    setLocation(selectedLocation);
  };

  const handleSave = () => {
    onSelectLocation(location);
    onClose();
    document.activeElement.blur();
  };

  useEffect(() => {
    if (
      mapRef.current &&
      mapsRef.current &&
      markerRef.current &&
      location.lat &&
      location.lng
    ) {
      const newPos = new mapsRef.current.LatLng(location.lat, location.lng);
      markerRef.current.setPosition(newPos);
      mapRef.current.panTo(newPos);
    }
  }, [location]);

  const Marker = () => (
    <div style={{ color: "red", fontWeight: "bold", fontSize: "20px" }}>📍</div>
  );

  return (
    <div className="map-content">
      <div className="d-flex">
        <div>
          <h2>Dirección fiscal:</h2>
          <PlacesAutocomplete onSelect={handleSelectLocation} />
        </div>
        <div
          style={{
            height: "400px",
            width: "500px",
            marginTop: "10px",
            marginLeft: "10px",
          }}
        >
          <GoogleMapReact
            key={`${location.lat}-${location.lng}`}
            bootstrapURLKeys={{ key: GOOGLE_MAPS_API_KEY }}
            defaultCenter={{ lat: 19.4326, lng: -99.1332 }}
            center={{ lat: location.lat, lng: location.lng }}
            defaultZoom={14}
            onClick={handleMapClick}
          >
            <Marker lat={location.lat} lng={location.lng} />
          </GoogleMapReact>
        </div>
      </div>

      <div className="button-container">
        <CustomButton
          text={"Guardar"}
          color={"#FFFFFF"}
          border={"none"}
          background={"#62C776"}
          fontStyle={"normal"}
          fontWeight={700}
          fontSize={"14px"}
          width={"75px"}
          height={"28px"}
          type={"button"}
          onClick={() => handleSave()}
        />
        <CustomButton
          text={"Cancelar"}
          color={"#FFFFFF"}
          border={"none"}
          background={"#C3C3C3"}
          fontStyle={"normal"}
          fontWeight={700}
          fontSize={"14px"}
          width={"75px"}
          height={"28px"}
          type={"button"}
          onClick={() => handleSave()}
        />
      </div>
    </div>
  );
};

export default MapModal;
